<template>
  <div>
    <div v-if="step == 'form'">
      <div class="form-group">
        <label for="useralias" class="control-label">Numer seryjny karty</label>
        <input
          type="text"
          name="useralias"
          id="useralias"
          v-model="useralias"
          :disabled="isRequestPending"
          class="form-control"
        />
        <small
          class="form-text text-danger"
          v-for="error in errors.useralias"
          :key="error"
          >{{ error }}</small
        >
      </div>
      <div class="form-group">
        <label for="credit" class="control-label">Kwota doładowania</label>
        <select
          class="form-control"
          :disabled="isRequestPending"
          id="credit"
          v-model="credit"
        >
          <option value="300">300 zł + 21 zł extra</option>
          <option value="200">200 zł + 14 zł extra</option>
          <option value="100">100 zł + 7 zł extra</option>
          <option value="50">50 zł</option>
          <option value="30">30 zł</option>
          <option value="20">20 zł</option>
          <option value="10">10 zł</option>
        </select>
        <small
          class="form-text text-danger"
          v-for="error in errors.credit"
          :key="error"
          >{{ error }}</small
        >
      </div>
      <div class="form-group">
        <label for="first-name" class="control-label">Imię</label>
        <input
          type="text"
          name="first-name"
          id="first-name"
          v-model="firstName"
          :disabled="isRequestPending"
          class="form-control"
        />
        <small
          class="form-text text-danger"
          v-for="error in errors.first_name"
          :key="error"
          >{{ error }}</small
        >
      </div>
      <div class="form-group">
        <label for="last-name" class="control-label">Nazwisko</label>
        <input
          type="text"
          name="last-name"
          id="last-name"
          v-model="lastName"
          :disabled="isRequestPending"
          class="form-control"
        />
        <small
          class="form-text text-danger"
          v-for="error in errors.last_name"
          :key="error"
          >{{ error }}</small
        >
      </div>
      <div class="form-group">
        <label for="email" class="control-label">Email</label>
        <input
          class="form-control"
          :disabled="isRequestPending"
          type="email"
          id="email"
          v-model="email"
        />
        <small
          class="form-text text-danger"
          v-for="error in errors.email"
          :key="error"
          >{{ error }}</small
        >
      </div>
      <div class="form-check">
        <label for="tos" class="form-check-label">
          <span class="checkbox">
            <input
              type="checkbox"
              :disabled="isRequestPending"
              id="tos"
              v-model="isTosAccepted"
              class="form-check-input"
            />
            <i></i>
          </span>
          Akceptuję Regulamin usług. Ze względu na charakter Usługi, która
          zostaje w pełni wykonana niezwłocznie, zostałem poinformowany o braku
          możliwości odstąpienia od umowy po jej wykonaniu.</label
        >
        <small class="form-text text-danger mb-2" v-if="tosError"
          >Do kontynuacji wymagana jest akceptacja regulaminu!</small
        >
      </div>
      <p class="mt-3">
        <small
          >Powyższe dane będą przetwarzane przez Dialtech sp. z o.o., adres: ul.
          Wilczak 16A/6, 61-623 Poznań, KRS: 0000335514 (nr tel. 61-820-99-00,
          e-mail: kontakt@dialtech.pl), w celu świadczenia usługi w postaci
          dokonania doładowania w celu realizacji połączeń telefonicznych
          zgodnie z Regulaminem. Ze szczegółową informacją w zakresie
          przetwarzania danych osobowych można zapoznać się tutaj tutaj.</small
        >
      </p>
      <button
        class="btn button"
        :disabled="isRequestPending"
        @click="submitForm"
      >
        Zatwierdź
      </button>
      <div v-if="generalError" class="mt-2">
        <small class="form-text text-danger"
          >Wystąpił błąd. Spróbuj ponownie za chwilę.</small
        >
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-4 offset-md-4">
          <table
            class="table table-borderless text-center"
            style="min-width: auto !important"
          >
            <tbody>
              <tr>
                <td colspan="2">Doładowanie karty {{ useralias }}</td>
              </tr>
              <tr>
                <th>Imię</th>
                <td>{{ firstName }}</td>
              </tr>
              <tr>
                <th>Nazwisko</th>
                <td>{{ lastName }}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{{ email }}</td>
              </tr>
              <tr>
                <th>Kwota doładowania</th>
                <td>{{ credit }} zł</td>
              </tr>
              <tr v-if="credit >= 100">
                <th>Gratis</th>
                <td>{{ (credit / 100) * 7 }} zł</td>
              </tr>
              <tr>
                <th colspan="2">Zamówienie z obowiązkiem zapłaty!</th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <form
        id="tpay-refill-form"
        class="text-center"
        target="_top"
        method="post"
        action="https://secure.tpay.com"
      >
        <input type="hidden" name="id" :value="tpayId" />
        <input type="hidden" name="kwota" :value="credit + '.00'" />
        <input
          type="hidden"
          name="opis"
          :value="'Doładowanie karty ' + useralias"
        />
        <input type="hidden" name="crc" :value="paymentId" />
        <input type="hidden" name="md5sum" :value="md5" />
        <input type="hidden" name="wyn_url" :value="notifyUrl" />
        <input type="hidden" name="pow_url" value="https://www.dialtech.pl" />
        <input type="hidden" name="wyn_email" value="admin@actio.pl" />
        <input type="hidden" name="imie" :value="firstName" />
        <input type="hidden" name="nazwisko" :value="lastName" />
        <input type="hidden" name="email" :value="email" />
        <input type="hidden" name="expiration_date" :value="expdate" />
        <input type="hidden" name="timehash" :value="timehash" />
        <button class="btn">Przejdź do płatności</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      useralias: "",
      firstName: "",
      lastName: "",
      credit: "10",
      email: "",
      errors: {
        useralias: [],
        first_name: [],
        last_name: [],
        credit: [],
        email: [],
      },
      isRequestPending: false,
      isTosAccepted: false,
      tosError: false,
      generalError: false,
      step: "form",
      md5: "",
      tpayId: "",
      notifyUrl: "",
      paymentId: null,
      expdate: "",
      timehash: "",
    };
  },

  methods: {
    submitForm() {
      if (this.isRequestPending) {
        return;
      }

      if (!this.isTosAccepted) {
        this.tosError = true;
        return;
      }

      this.tosError = false;
      this.isRequestPending = true;

      window.axios
        .post("/dialtech/api/refills", {
          useralias: this.useralias,
          credit: this.credit,
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
        })
        .then((response) => {
          if (response.data.status === "ERROR") {
            this.errors = response.data.errors;
            this.isRequestPending = false;
          }

          if (response.data.status == "OK") {
            this.step = "summary";
            this.md5 = response.data.md5;
            this.tpayId = response.data.tpayId;
            this.notifyUrl = response.data.notifyUrl;
            this.paymentId = response.data.paymentId;
            this.expdate = response.data.expirationdate;
            this.timehash = response.data.timehash;
          }
        })
        .catch(() => {
          this.generalError = true;
          setTimeout(() => {
            this.isRequestPending = false;
          }, 2000);
        });
    },
  },
};
</script>